export function fromSnakeOrKebabCaseToNatural(s) {
    s = s
        .replaceAll("_", " ")
        .replaceAll("-", " ")
        .toLowerCase();
    s = capitalizeFirstLetter(s);
    return s;
}

export function capitalizeFirstLetter(s) {
    return s.substr(0, 1).toUpperCase() + s.substr(1, s.length - 1);
}

export function replaceChartAt(s, insert, i) {
    return s.substr(0, i).toUpperCase() + s.substr(i, s.length - insert.length);
}

export function convertToIng(s) {
    let words = s.split(" ");
    words[0] = convertWordToIng(words[0]);
    return words.join(" ");
}

export function convertToParticiple(s) {
    let words = s.split(" ");
    words[0] = convertWordToParticiple(words[0]);
    return words.join(" ");
}

function convertWordToIng(w) {
    if (getLastChar(w) === "e") {
        w = w.substr(0, w.length - 1);
    } else if ((countVowels(w) === 1 && endsWithVowelPlusConsonant(w)) || w.endsWith("el")) {
        w += getLastChar(w);
    }
    w += "ing";
    return w;
}

function convertWordToParticiple(w) {
    if (w === "send") {
        return "sent";
    } else if (getLastChar(w) === "e") {
        w = w.substr(0, w.length - 1);
    } else if ((countVowels(w) === 1 && endsWithVowelPlusConsonant(w)) || w.endsWith("el")) {
        w += getLastChar(w);
    }
    w += "ed";
    return w;
}

function countVowels(s) {
    return Array.from(s.toLowerCase()).filter(letter => "aeiou".includes(letter)).length;
}

function endsWithVowelPlusConsonant(s) {
    if (endsWithConsonant(s)) {
        s = s.slice(0, -1);
        return endsWithVowel(s);
    }
    return false;
}

function endsWithConsonant(s) {
    const lastChar = getLastChar(s);
    return isConsonant(lastChar);
}

function endsWithVowel(s) {
    return !endsWithConsonant(s);
}

function getLastChar(s) {
    return s.split("").pop();
}

function isConsonant(c) {
    return countVowels(c) === 0;
}
